@if (breakpointService.isDesktop()) {
    <div class="viator" [class.viator--empty]="!isFetching && !viArray.length">
        <button class="viator__reset"
                [class.show-filter]="showFilters"
                (click)="toggleFilters()">
            {{ (showFilters ? 'VIATOR.HIDE_FILTERS' : 'VIATOR.SHOW_FILTERS') | translate }}
        </button>
        <div class="viator__filters" [class.show-filter]="showFilters">
            @if (!isFetching) {
                @for (filter of filters; track filter.name) {
                    <div class="filter-item">
                        <mat-checkbox
                                [checked]="filter.selected"
                                (change)="onFilterChange(filter.name, $event.checked)">
                            {{ filter.name }}
                        </mat-checkbox>
                        <span class="viator__count">{{ filter.count }}</span>
                    </div>
                }
            } @else {
                @for (vi of fetchingFilters; track $index) {
                    <ngx-skeleton-loader
                            [theme]="{height: 20 + 'px', margin: '0px 14px', marginBottom: '7px', maxWidth: '70%'}"
                    ></ngx-skeleton-loader>
                }
            }
        </div>
        <div class="viator__groups" [class.show-filter]="showFilters">
            @if (!isFetching) {
                @if (viArray.length) {
                    @for (vi of viArray; track vi.type) {
                        <div class="viator-group">
                            <h3 class="viator-group__title">{{ vi.type }}
                                <mat-icon [svgIcon]="eSvgIcons.ARROW_RIGHT"></mat-icon>
                            </h3>
                            <app-viator-group
                                    [isFetching]="isFetching"
                                    [events]="vi.events | slice: 0: 100"
                                    [placeId]="cityId"
                                    [countryName]="countryName"
                                    [cityName]="cityName"
                                    (bookNow)="clickBookNow(vi, $event)"
                            ></app-viator-group>
                        </div>
                    }
                } @else {
                    <app-no-items-found title="EMPTY.VIATOR"></app-no-items-found>
                }
            } @else {
                @for (vi of fetchingItems; track $index) {
                    <div class="viator-group">
                        <ngx-skeleton-loader
                                [theme]="{height: 40 + 'px', margin: 0, marginBottom: '15px', maxWidth: '30%'}"></ngx-skeleton-loader>
                        <app-viator-group
                                [isFetching]="isFetching"
                                [events]="[null, null, null, null, null, null, null]"
                        ></app-viator-group>
                    </div>
                }
            }
        </div>
    </div>
} @else {
    <app-viator-list-mobile
            [cityId]="cityId"
            [cityName]="cityName"
            [countryName]="countryName"
            [groupViator]="viArray"
            [isFetching]="isFetching"
    ></app-viator-list-mobile>
}
